import { FormType } from "../../models";
import RequestFrom from "./RequestForm";

const CreateAccount = () => {
  return (
    <div className="py-5">
      <RequestFrom formType={FormType.CreateAccount} />
    </div>
  );
};

export default CreateAccount;
